import { render, staticRenderFns } from "./PhysicalActivityChart.vue?vue&type=template&id=1d38244a&"
import script from "./PhysicalActivityChart.vue?vue&type=script&lang=js&"
export * from "./PhysicalActivityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports